/**
 * Numeric / string design tokens shared by both apps' ResponsiveSheet shells.
 * Tweaking any value here propagates to both apps/web and apps/app — the only
 * source of truth for sheet behavior.
 */

/** Mobile bottom-sheet maximum height. dvh handles iOS toolbar collapse. */
export const SHEET_MAX_HEIGHT_MOBILE = "85dvh";

/** Desktop centered modal maximum height. */
export const SHEET_MAX_HEIGHT_DESKTOP = "90vh";

/**
 * Pixel offset past which release dismisses the sheet. Tuned from real-world
 * gesture data (debug logs showed users dropping at ~20-50px); 80px was too
 * high, 50px catches deliberate small-flick swipes without false positives.
 */
export const SHEET_DRAG_DISMISS_OFFSET_PX = 50;

/**
 * Drag velocity (px/sec) past which release dismisses regardless of offset.
 * 500 was too aggressive for slow flicks; 250 captures deliberate-but-not-fast
 * dismiss intent. Matches SwipeableTabsContent velocityThreshold.
 */
export const SHEET_DRAG_DISMISS_VELOCITY = 250;

/** Top elastic factor (0 = rigid). Mobile sheets pin to top. */
export const SHEET_DRAG_ELASTIC_TOP = 0;

/** Bottom elastic factor — light overshoot before release. */
export const SHEET_DRAG_ELASTIC_BOTTOM = 0.5;

/**
 * Spring config for sheet enter / settle. Matches base-ui Sheet timing so
 * both stacks feel the same.
 */
export const SHEET_SPRING = {
  type: "spring" as const,
  damping: 30,
  stiffness: 320,
  mass: 0.8,
};

/** Backdrop fade duration on enter / exit. Matches dialog enter timing so
 * backdrop and panel feel like one motion, not two staggered fades. */
export const SHEET_BACKDROP_DURATION_S = 0.14;

/** Mobile breakpoint matched on the client (sheet → dialog). */
export const SHEET_DESKTOP_MIN_WIDTH_PX = 640; // sm: in Tailwind defaults

/** Z-index layering — backdrop sits one below sheet, both above page chrome. */
export const SHEET_Z_BACKDROP = 2998;
export const SHEET_Z_PANEL = 2999;
